module.exports = __webpack_public_path__ + "img/Step1-m.34a9ea0.svg";